export default {
  methods: {
    getVerbiage(name, defaultValue) {
      const productData = this.getSettings('selectedProduct.custom', {})
      return _.get(productData, name) || defaultValue
    }
  }
}
